import i18n from 'modules/core/lib/i18n'

import { DurationUnit } from 'modules/timeoff/lib/BlockedPeriods/TimePeriod'
import { TENURE_BALANCE_TYPES, TENURE_PERIOD_TYPES } from 'modules/timeoff/lib/TenurePeriod'
import {
  AvailabilityOptionsForFixedBalance,
  AvailabilityOptionsForWorkedTime,
} from 'modules/timeoff/lib/enums'
import Allowance, { EMPLOYEE_HIRED_DATE } from 'modules/timeoff/store/models/Allowance'

export const cycleBeginOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.CYCLE_START.jan:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.jan')
    case Allowance.CYCLE_START.feb:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.feb')
    case Allowance.CYCLE_START.mar:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.mar')
    case Allowance.CYCLE_START.apr:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.apr')
    case Allowance.CYCLE_START.may:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.may')
    case Allowance.CYCLE_START.jun:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.jun')
    case Allowance.CYCLE_START.jul:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.jul')
    case Allowance.CYCLE_START.aug:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.aug')
    case Allowance.CYCLE_START.sep:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.sep')
    case Allowance.CYCLE_START.oct:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.oct')
    case Allowance.CYCLE_START.nov:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.nov')
    case Allowance.CYCLE_START.dec:
      return i18n.t('time_off.allowances.fields.cycle_settings.cycle_begin_options.dec')
    case Allowance.CYCLE_START.employee_hired_date:
      return i18n.t(
        'time_off.allowances.fields.cycle_settings.cycle_begin_options.employee_hired_date'
      )
    default:
      throw new Error(`Missing translation for cycle_settings.cycle_begin_options.${key}`)
  }
}

export const allowanceTypeOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.ALLOWANCE_TYPES.days:
      return i18n.t('time_off.allowances.fields.allowance_type_options.days')
    case Allowance.ALLOWANCE_TYPES.hours:
      return i18n.t('time_off.allowances.fields.allowance_type_options.hours')
    default:
      throw new Error(`Missing translation for allowance_type_options.${key}`)
  }
}

export const roudingDaysOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.ROUNDING_OPTIONS_DAYS.half_day:
      return i18n.t('time_off.allowances.fields.rounding_days.half_day')
    case Allowance.ROUNDING_OPTIONS_DAYS.round_up:
      return i18n.t('time_off.allowances.fields.rounding_days.round_up')
    case Allowance.ROUNDING_OPTIONS_DAYS.decimals:
      return i18n.t('time_off.allowances.fields.rounding_days.decimals')
    default:
      throw new Error(`Missing translation for rounding_days.${key}`)
  }
}

export const roudingHoursOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.ROUNDING_OPTIONS_HOURS.half_day:
      return i18n.t('time_off.allowances.fields.rounding_hours.half_day')
    case Allowance.ROUNDING_OPTIONS_HOURS.decimals:
      return i18n.t('time_off.allowances.fields.rounding_hours.decimals')
    case Allowance.ROUNDING_OPTIONS_HOURS.quarters:
      return i18n.t('time_off.allowances.fields.rounding_hours.quarters')
    default:
      throw new Error(`Missing translation for rounding_hours.${key}`)
  }
}

export const sourceUnitsOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.SOURCE_UNITS.base_units:
      return i18n.t('time_off.allowances.fields.source_units.base_units')
    case Allowance.SOURCE_UNITS.by_worked_time:
      return i18n.t('time_off.allowances.fields.source_units.time_worked')
    case Allowance.SOURCE_UNITS.overtime_units:
      return i18n.t('time_off.allowances.fields.source_units.overtime_units')
    default:
      throw new Error(`Missing translation for source_units.${key}`)
  }
}

export const daysTypeOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.DAYS_TYPE.natural_days:
      return i18n.t('time_off.allowances.fields.days_type_options.natural_days')
    case Allowance.DAYS_TYPE.working_days:
      return i18n.t('time_off.allowances.fields.days_type_options.working_days')
    case Allowance.DAYS_TYPE.french_calendar_days:
      return i18n.t('time_off.allowances.fields.days_type_options.french_calendar_days')
    case Allowance.DAYS_TYPE.french_ouvres:
      return i18n.t('time_off.allowances.fields.days_type_options.french_ouvres')
    default:
      throw new Error(`Missing translation for days_type_options.${key}`)
  }
}

export const hoursTypeOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.DAYS_TYPE.natural_days:
      return i18n.t('time_off.allowances.fields.hours_type_options.natural_days')
    case Allowance.DAYS_TYPE.working_days:
      return i18n.t('time_off.allowances.fields.hours_type_options.working_days')
    default:
      throw new Error(`Missing translation for hours_type_options.${key}`)
  }
}

export const negativeCounterDaysOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.NEGATIVE_COUNTER_TYPE.negative_counter_disabled:
      return i18n.t(
        'time_off.allowances.fields.negative_counter_days_options.negative_counter_disabled'
      )
    case Allowance.NEGATIVE_COUNTER_TYPE.negative_counter_enabled:
      return i18n.t(
        'time_off.allowances.fields.negative_counter_days_options.negative_counter_enabled'
      )
    default:
      throw new Error(`Missing translation for negative_counter_days_options.${key}`)
  }
}

export const negativeCounterHoursOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.NEGATIVE_COUNTER_TYPE.negative_counter_disabled:
      return i18n.t(
        'time_off.allowances.fields.negative_counter_hours_options.negative_counter_disabled'
      )
    case Allowance.NEGATIVE_COUNTER_TYPE.negative_counter_enabled:
      return i18n.t(
        'time_off.allowances.fields.negative_counter_hours_options.negative_counter_enabled'
      )
    default:
      throw new Error(`Missing translation for negative_counter_hours_options.${key}`)
  }
}

export const limitNegativeCounterOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.LIMIT_NEGATIVE_COUNTER_TYPE.limit_negative_counter:
      return i18n.t(
        'time_off.allowances.fields.limit_negative_counter_options.limit_negative_counter'
      )
    case Allowance.LIMIT_NEGATIVE_COUNTER_TYPE.no_limit:
      return i18n.t('time_off.allowances.fields.limit_negative_counter_options.no_limit')
    default:
      throw new Error(`Missing translation for limit_negative_counter_options.${key}`)
  }
}

export const prorationTypeDaysOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.PRORATION_TYPE.proration_enabled:
      return i18n.t('time_off.allowances.fields.proration_type_days_options.proration_enabled')
    case Allowance.PRORATION_TYPE.proration_disabled:
      return i18n.t('time_off.allowances.fields.proration_type_days_options.proration_disabled')
    default:
      throw new Error(`Missing translation for proration_type_days_options.${key}`)
  }
}

export const prorationTypeHoursOptionsLabel = (key: string): string => {
  switch (key) {
    case Allowance.PRORATION_TYPE.proration_enabled:
      return i18n.t('time_off.allowances.fields.proration_type_hours_options.proration_enabled')
    case Allowance.PRORATION_TYPE.proration_disabled:
      return i18n.t('time_off.allowances.fields.proration_type_hours_options.proration_disabled')
    default:
      throw new Error(`Missing translation for proration_type_hours_options.${key}`)
  }
}

export const availableOptionsDaysLabels = (key: string): string => {
  switch (key) {
    case Allowance.AVAILABLE_OPTIONS_DAYS.all_days:
      return i18n.t('time_off.allowances.fields.available_days_options.all_days')
    case Allowance.AVAILABLE_OPTIONS_DAYS.generated_days:
      return i18n.t('time_off.allowances.fields.available_days_options.generated_days')
    case Allowance.AVAILABLE_OPTIONS_DAYS.generated_days_monthly:
      return i18n.t('time_off.allowances.fields.available_days_options.generated_days_monthly')
    case AvailabilityOptionsForFixedBalance.MonthlyFirstDay:
      return i18n.t(
        'time_off.allowances.fields.available_days_options.generated_days_monthly_first_day'
      )
    case AvailabilityOptionsForFixedBalance.BimonthlyFirstAndFifteenth:
      return i18n.t('time_off.allowances.fields.availability_options.bimonthly_first_and_fifteenth')
    case AvailabilityOptionsForFixedBalance.BimonthlyFifteenthAndLast:
      return i18n.t('time_off.allowances.fields.availability_options.bimonthly_fifteenth_and_last')
    default:
      throw new Error(`Missing translation for available_days_options.${key}`)
  }
}

export const availabilityOptionsForFixedBalanceLabels = (key: string): string => {
  switch (key) {
    case AvailabilityOptionsForFixedBalance.AllDays:
      return i18n.t('time_off.allowances.fields.availability_options.all_at_once')
    case AvailabilityOptionsForFixedBalance.Daily:
      return i18n.t('time_off.allowances.fields.availability_options.generated_days')
    case AvailabilityOptionsForFixedBalance.Mensiversary:
      return i18n.t('time_off.allowances.fields.availability_options.mensiversary')
    case AvailabilityOptionsForFixedBalance.MonthlyFirstDay:
      return i18n.t(
        'time_off.allowances.fields.availability_options.generated_days_monthly_first_day'
      )
    case AvailabilityOptionsForFixedBalance.MonthlyFifteenth:
      return i18n.t('time_off.allowances.fields.availability_options.monthly_fifteenth')
    case AvailabilityOptionsForFixedBalance.MonthlyLastDay:
      return i18n.t('time_off.allowances.fields.availability_options.generated_days_monthly')
    case AvailabilityOptionsForFixedBalance.BimonthlyFirstAndFifteenth:
      return i18n.t('time_off.allowances.fields.availability_options.bimonthly_first_and_fifteenth')
    case AvailabilityOptionsForFixedBalance.BimonthlyFifteenthAndLast:
      return i18n.t('time_off.allowances.fields.availability_options.bimonthly_fifteenth_and_last')
    default:
      throw new Error(`Missing translation for availability_options.${key}`)
  }
}

export const availabilityOptionsForWorkedTimeLabels = (key: string): string => {
  switch (key) {
    case AvailabilityOptionsForWorkedTime.AllDays:
      return i18n.t('time_off.allowances.fields.availability_options.on_clock_out')
    case AvailabilityOptionsForWorkedTime.BimonthlyFirstAndFifteenth:
      return i18n.t('time_off.allowances.fields.availability_options.bimonthly_first_and_fifteenth')
    case AvailabilityOptionsForWorkedTime.BimonthlyFifteenthAndLast:
      return i18n.t('time_off.allowances.fields.availability_options.bimonthly_fifteenth_and_last')
    default:
      throw new Error(`Missing translation for availability_options.${key}`)
  }
}

export const availableOptionsHoursLabels = (key: string): string => {
  switch (key) {
    case Allowance.AVAILABLE_OPTIONS_DAYS.all_days:
      return i18n.t('time_off.allowances.fields.available_hours_options.all_days')
    case Allowance.AVAILABLE_OPTIONS_DAYS.generated_days:
      return i18n.t('time_off.allowances.fields.available_hours_options.generated_days')
    case Allowance.AVAILABLE_OPTIONS_DAYS.generated_days_monthly:
      return i18n.t('time_off.allowances.fields.available_hours_options.generated_days_monthly')
    case AvailabilityOptionsForFixedBalance.MonthlyFirstDay:
      return i18n.t(
        'time_off.allowances.fields.available_hours_options.generated_days_monthly_first_day'
      )
    default:
      throw new Error(`Missing translation for available_hours_options.${key}`)
  }
}

export const tenurePeriodTypes = (key: string): string => {
  switch (key) {
    case TENURE_PERIOD_TYPES.years:
      return i18n.t('time_off.allowances.page.tenure_period_types.years')
    case TENURE_PERIOD_TYPES.months:
      return i18n.t('time_off.allowances.page.tenure_period_types.months')
    default:
      throw new Error(`Missing translation for available_hours_options.${key}`)
  }
}

export const tenureBalanceTypes = (key: string): string => {
  switch (key) {
    case TENURE_BALANCE_TYPES.fixed_balance:
      return i18n.t('time_off.allowances.fields.source_units.base_units')
    case TENURE_BALANCE_TYPES.time_worked_based:
      return i18n.t('time_off.allowances.fields.source_units.time_worked')
    default:
      throw new Error(`Missing translation for available_hours_options.${key}`)
  }
}

export const tenurePeriodTransitionOptions = (key: string): string => {
  switch (key) {
    case Allowance.TENURE_PERIOD_TRANSITION.after_milestone:
      return i18n.t('time_off.allowances.page.tenure_period_transitions.after_milestone')
    case Allowance.TENURE_PERIOD_TRANSITION.beginning_of_cycle:
      return i18n.t('time_off.allowances.page.tenure_period_transitions.beginning_of_cycle')
    case Allowance.TENURE_PERIOD_TRANSITION.end_of_cycle:
      return i18n.t('time_off.allowances.page.tenure_period_transitions.end_of_cycle')
    default:
      throw new Error(`Missing translation for tenure_period_transitions.${key}`)
  }
}

export const blockedPeriodsDurationUnitOptions = (key: string): string => {
  switch (key) {
    case DurationUnit.days:
      return i18n.t('settings.timeoff_blocked_periods.fields.time_period.duration_unit.days')
    case DurationUnit.months:
      return i18n.t('settings.timeoff_blocked_periods.fields.time_period.duration_unit.months')
    default:
      throw new Error(
        `Missing translation for timeoff_blocked_periods.fields.time_period.duration_unit.${key}`
      )
  }
}

export const timeoffCycleOptionsLabel = (key: string): string => {
  switch (key) {
    case 'jan_dec':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.jan_dec')
    case 'feb_jan':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.feb_jan')
    case 'mar_feb':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.mar_feb')
    case 'apr_mar':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.apr_mar')
    case 'may_apr':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.may_apr')
    case 'jun_may':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.jun_may')
    case 'jul_jun':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.jul_jun')
    case 'aug_jul':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.aug_jul')
    case 'sep_aug':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.sep_aug')
    case 'oct_sep':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.oct_sep')
    case 'nov_oct':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.nov_oct')
    case 'dec_nov':
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.dec_nov')
    case EMPLOYEE_HIRED_DATE:
      return i18n.t('time_off.allowances.page.timeoff_cycle_options.employee_hired_date')
    default:
      throw new Error(
        `Missing translation for time_off.allowances.page.timeoff_cycle_options.${key}`
      )
  }
}
